import { useQuery } from "react-query";
import { getCreditCardFormParams } from "./gateway";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

export function useCreditCardFormData(
  mode: string,
  appId?: string | null,
  year?: string,
  finePaymentId?: number,
) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  return useQuery({
    queryFn: () => getCreditCardFormParams(mode, appId, year, finePaymentId),
    queryKey: ["creditCardFormParams", mode, appId, year, finePaymentId],
    onError: (err: AxiosError) => { 
      if (err?.response?.status === 400) {
        enqueueSnackbar(t("Παρουσιάστηκε σφάλμα στη διαδικασία."), { variant: "error" });
        navigate("/business/dashboard");
      }
    },
  });
}